<template>
  <div v-if="value" data-component="Widget/DatePickerButton">
    <div>
      <span v-if="hasUnsyncedData" class="mutation-cloud-icon" title="Données en attente de synchronisation">☁</span>
      <p>
        <strong>{{ formatDisplayDate(value) }}</strong>
      </p>
      <p>
        <input 
          type="date" 
          :id="id" 
          :value="formatInputDate(value)" 
          @change="handleChange" 
        />
        <small>Modifier</small>
      </p>
      <p @click="handleReset"><small>Réinitialiser</small></p>
    </div>
  </div>
  <button 
    v-else 
    class="action-button is-date-picker"
    type="button"
  >
    <label :for="id">
      <slot>À planifier</slot>
      <i class="ico datepicker" />
    </label>
    <input 
      type="date" 
      :id="id" 
      :value="value || ''" 
      @change="handleChange" 
    />
  </button>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DatePickerButton',
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    // Indicateur si la propriété a des données en attente de synchronisation
    hasUnsyncedData: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change', 'reset'],
  methods: {
    formatDisplayDate(date) {
      if (!date) return ''
      return moment(date).format('DD/MM/YYYY')
    },
    formatInputDate(date) {
      if (!date) return ''
      return moment(date).format('YYYY-MM-DD')
    },
    handleChange(event) {
      this.$emit('change', event.target.value)
    },
    handleReset() {
      this.$emit('reset')
    }
  }
}
</script>

<style lang="scss" scoped>
/* Styles globaux dans src/assets/styles/components/Widget.scss */
</style>
